import React from 'react';
require('style/ConfigChangeTracker');

class ConfigChangeTracker extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            developerMode: false,
            reason: "-1",
            note:"",
            checkLater:false
        }
    }
    reasonChanged = (e) => {
        this.setState({ reason: e.target.value });
        this.props.handleReasonChanged(e.target.value);
    }
    checkChanged = (e) => {
        this.setState({ checkLater: e.target.checked })
        this.props.handleCheckLaterChange(e.target.checked);
    }
    noteChanged = (e) => {
        this.setState({note:e.target.value});
        this.props.handleNoteChange(e.target.value);
    }

    render() {
        var reasons = [
            <option key="readermoved" value="readerMoved">Reader moved</option>,
            <option key="improveConfig" value="improveConfig">Improve config</option>,
            <option key="skip" value="ignore">Improve config (not shown in ConfigHistory)</option>,
            <option key="newdevice" value="newDevice">New device</option>,
            <option key="meterchanged" value="meterChanged">Meter changed</option>,
        ];
        return <div className="ConfigChangeTracker">
            <div className='mainContainer'>
                <div className='leftContainer'>
                    <div className='itemDiv'>
                        <span className='controlLabel'>Config reason:<span style={{color:"red"}}>*</span></span>
                        <select className='reasonSelect' value={this.state.reason} onChange={this.reasonChanged}>
                            <option key="default" value="-1">Choose reason</option>
                            {reasons}
                        </select>
                    </div>
                    <div className='itemDiv'>
                        <label>Check later</label>
                        <input type="checkbox" onChange={this.checkChanged}></input>
                    </div>
                    <div className='itemDiv'>
                        <div>Note:</div>
                        <textarea className="textArea" onChange={this.noteChanged}></textarea>
                    </div>
                </div>
            </div>
        </div>
    }
}

export default ConfigChangeTracker;


// WEBPACK FOOTER //
// ./client/components/ConfigChangeTracker.js